import React, { PropsWithChildren } from "react";

type SubsectionWithFieldsProps = {};

export const SubsectionWithFields: React.FC<
    PropsWithChildren<SubsectionWithFieldsProps>
> = ({ children }) => {
    return (
        <>
            <div className="grid gap-y-4 gap-x-10 sm:gap-y-6 xl:grid-cols-2 xl:gap-y-9">
                {children}
            </div>
        </>
    );
};
